module.exports = __webpack_public_path__ + "phone_70x70.2046ff960efebf0555d57714953d19cb.png";